import React from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

const useStyles = makeStyles((theme) => ({  
  buttons: {
    paddingLeft: 20
  }
}));

export default function RecipeReviewCard(props) {
  const classes = useStyles();
  const { selectedValue, setSelectedValue, selectedValue1, setSelectedValue1, selectedValue2, setSelectedValue2, awsstate, setAwsState, setAwsfind, } = props;

  const [awsrolelist, setAwsrolelist] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/awsroleslist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setAwsrolelist(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);


  const [instancelist, setinstancelist] = React.useState([]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/ec2instancelist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setinstancelist(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);


  const [rdsinstancelist, setrdsinstancelist] = React.useState([]);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/rdsinstancelist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setrdsinstancelist(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleChange1 = (event) => {
    setSelectedValue1(event.target.value);  
  };

  const handleChange2 = (event) => {
    setSelectedValue2(event.target.value);    
  };

  const handleRolesChange = (event) => {
    setAwsfind(true);
    setAwsState({ ...awsstate, [event.target.name]: event.target.checked });
  };

  return (
    <>
      <Card>
        <CardHeader
          avatar={
            <Radio
              checked={selectedValue === "b"}
              onChange={handleChange}
              value="b"
              name="radio-button-demo"
              inputProps={{ "aria-label": "B" }}
            />
          }
          title={<strong>Limited Access</strong>}
          subheader="Provides full access for selected resources"
        />
      </Card>
      {selectedValue === "b" ? (
        <Box sx={{ pt: 5 }}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Add Resources:</FormLabel>
            <Divider />
            <FormGroup>
              {awsrolelist.map((data) => {
                if (data.role !== "admin") {
                  return (
                    <React.Fragment>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={awsstate[data.role]}
                          onChange={handleRolesChange}
                          name={data.role}
                        />
                      }
                      label={data.name}
                    />         
                    {awsstate[data.role] && data.role === "ec2" ? (
                    <React.Fragment>
                        {instancelist.map((instancelist) => {
                         
                          return (
                            <FormControlLabel
                            className={classes.buttons}
                            control={
                            <Radio
                              checked={selectedValue1 === instancelist.instance_type}
                              onChange={handleChange1}                              
                              value={instancelist.instance_type}
                              name={instancelist.instance_type}
                              inputProps={{ "aria-label": instancelist.instance_type }}                              
                              size="small"                              
                            />
                            }
                            label={instancelist.name}
                            />
                          );                         
                        })}
                    </React.Fragment>
                    ) 
                    : awsstate[data.role] && data.role === "rds" ? (
                      <React.Fragment>
                          {rdsinstancelist.map((instancelist) => {
                           
                            return (
                              <FormControlLabel
                              className={classes.buttons}
                              control={
                              <Radio
                                checked={selectedValue2 === instancelist.instance_type}
                                onChange={handleChange2}
                                value={instancelist.instance_type}
                                name={instancelist.instance_type}
                                inputProps={{ "aria-label": instancelist.instance_type }}                              
                                size="small"                              
                              />
                              }
                              label={instancelist.name}
                              />
                            );                         
                          })}
                      </React.Fragment>
                      ) 
                    : ""}
                    </React.Fragment>                        
                  );                  
                }
              })}             
            </FormGroup>
          </FormControl>
        </Box>
      ) : (
        ""
      )}
    </>
  );
}
